(() => {
  'use strict';

  const source = document.currentScript;
  const cssUrl = source?.dataset.btCodCss || '';
  const scriptUrl = source?.dataset.btCodScript || '';
  const cartIntentSelector = [
    '[data-bt-cod-open]',
    '[aria-controls="CartDrawer"]',
    '[aria-controls="cart-drawer"]',
    'a[href$="/cart"]',
    'a[href*="/cart?"]',
    'hdt-cart-drawer'
  ].join(',');

  let loadPromise = null;

  function loadStyles() {
    if (!cssUrl || document.querySelector('link[data-bt-cod-styles]')) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssUrl;
    link.dataset.btCodStyles = '';
    document.head.appendChild(link);
  }

  function load() {
    if (customElements.get('bt-cod-form')) return Promise.resolve(true);
    if (loadPromise) return loadPromise;

    loadStyles();
    loadPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-bt-cod-runtime]');
      const script = existing || document.createElement('script');
      const done = () => resolve(true);
      const failed = () => {
        loadPromise = null;
        reject(new Error('COD assets failed to load'));
      };

      script.addEventListener('load', done, { once: true });
      script.addEventListener('error', failed, { once: true });
      if (!existing) {
        script.type = 'module';
        script.src = scriptUrl;
        script.dataset.btCodRuntime = '';
        document.head.appendChild(script);
      }
    }).catch(() => false);

    return loadPromise;
  }

  function hasCartIntent(event) {
    return Boolean(event.target?.closest?.(cartIntentSelector));
  }

  function warmOnIntent(event) {
    if (hasCartIntent(event)) load();
  }

  window.BTLoadCod = load;
  document.addEventListener('pointerover', warmOnIntent, { capture: true, passive: true });
  document.addEventListener('pointerdown', warmOnIntent, { capture: true, passive: true });
  document.addEventListener('focusin', warmOnIntent, true);
  document.addEventListener('click', warmOnIntent, true);
  document.addEventListener('dialog:open', (event) => {
    const dialog = event.target;
    if (dialog?.id === 'CartDrawer' || dialog?.closest?.('#CartDrawer')) load();
  });
  ['cart:drawer:render', 'cart:main:render'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      const drawer = event.target?.closest?.('#CartDrawer') || document.querySelector('#CartDrawer');
      if (drawer?.hasAttribute('open') || document.documentElement.classList.contains('hdt-drawer-open')) load();
    });
  });

  // The theme applies the page-type class to <body>, not <html>. Load the
  // eligibility runtime immediately on the full cart page so the initially
  // hidden COD trigger can be revealed as soon as eligibility is confirmed.
  if (
    document.body?.classList.contains('hdt-page-type-cart') ||
    document.documentElement.classList.contains('hdt-page-type-cart')
  ) load();
})();
